import { Box } from "@mui/material";
import { LOCAL_STORAGE_GRID_KEYS } from "../../../_constants";
import { getGridContextMenuList } from "../../../_helpers/getGridContextMenuList";
import { LabelColumnV2 } from "../../../components/DataGridV2/DataColumnsV2";
import { Image } from "@mui/icons-material";
import { URLS } from "../../../apis/urls";
import { formatDate, formatDateForFilter } from "../../../_helpers";
const { webApiUrl } = window.appConfig;


export const getExistingRepairRequestImageColumns = ({
    t,
    keyPrefix,
    i18n,
    apiRef,
    selected,
    handleImageContainerOpen,
    prefix,
    statusOptions
}) => {

    const getOptions = getGridContextMenuList({
        filterKey: LOCAL_STORAGE_GRID_KEYS[`${prefix}_COLUMN_FILTER`]?.[keyPrefix],
        sortKey: LOCAL_STORAGE_GRID_KEYS[`${prefix}_COLUMN_SORT`]?.[keyPrefix],
        i18n,
        t,
        apiRef,
        mode: "client",
        getValueForFilter: (rowData, extraData) => {
            let value = ""
            switch (extraData.fieldName) {
                case "date":
                    value = formatDateForFilter(rowData.date)
                    break;
                default:
                    value = rowData[extraData.fieldName]
                    break;
            }
            return value
        },
        getValueForCopy: (rowData, extraData) => {
            let value = ""
            switch (extraData.fieldName) {
                case "date":
                    value = rowData.date ? formatDate(new Date(rowData.date)) : ''
                    break;
                default:
                    value = rowData?.[extraData?.fieldName]
                    break;
            }
            return value
        }
    })

    return [
        {
            download: false,
            print: true,
            field: "attachments",
            headerName: t("general.image"),
            editable: false,
            disableColumnMenu: true,
            flex: 1,
            align: "center",
            filterable: false,
            minWidth: 45,
            maxWidth: 45,
            forceApplyWidth: true,
            sortable: false,
            renderCell: (params) => {
                let imageURL = "";
                const rowData = params.row
                const index = rowData.requestId;
                const attachments = rowData.attachments;
                if (attachments[0] && !attachments[0].id && typeof (attachments[0]) !== "string") {
                    imageURL = `url(${window.URL.createObjectURL(new Blob([attachments[0]]))})`;
                } else if (attachments[0]) {
                    imageURL = `url(${URLS.GET_ATTACHMENT_THUMBNAIL}${attachments[0].id}),url(${webApiUrl}api/home/ProjectBackground/${selected.projectId})`;
                }
                return (
                    <Box
                        onClick={(e) => attachments.length && handleImageContainerOpen(e, attachments.map(p => ({ attachmentId: p.id, repairRequestId: rowData.requestId })))}
                        sx={[
                            {
                                boxShadow: 1,
                                borderRadius: 1,
                                width: 20,
                                height: 20,
                                backgroundImage: imageURL,
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                "&:hover": {
                                    transform: "scale(3)",
                                    position: "absolute",
                                    zIndex: 1000,
                                },
                            },
                            index === 0
                                ? {
                                    "&:hover": {
                                        marginTop: '30px'
                                    }
                                }
                                : {
                                    "&:hover": {
                                        marginTop: 0
                                    }
                                }
                        ]}
                    />
                );
            },
            renderHeader: () => {
                return (
                    (<Box component="div" sx={{
                        textAlign: "center"
                    }}>
                        <Image />
                    </Box>)
                );
            },
        },
        {
            field: "number",
            headerName: t("general.number"),
            flex: 1,
            download: true,
            print: true,
            align: "start",
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.number}
                        cellSubMenuOptions={{ options: getOptions({ field: "number", isQuickFilterDisplay: rowData?.number }), extraData: { fieldName: "number", } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "date",
            type: "date",
            headerName: t("general.date"),
            minWidth: 83,
            flex: 1,
            align: "start",
            valueGetter: (params) => {
                if (!params) return "";
                return new Date(params);
            },
            renderCell: (params) => {
                const request = params.row;
                if (!request) return "";
                return <LabelColumnV2
                    date={request.date}
                    cellSubMenuOptions={{ options: getOptions({ field: "date", isQuickFilterDisplay: Boolean(request.date) }), extraData: { fieldName: "date", type: "date" } }}
                    request={request} />;
            },
        },
        {
            field: "location",
            headerName: t("general.objectAddress"),
            flex: 1,
            align: "start",
            minWidth: 90,
            sortable: 'true',
            download: true,
            print: true,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.location}
                        cellSubMenuOptions={{ options: getOptions({ field: "location", isQuickFilterDisplay: rowData?.location }), extraData: { fieldName: "location", } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "desc",
            headerName: t("general.description"),
            flex: 1,
            align: "start",
            minWidth: 100,
            renderCell: (params) => {
                const rowData = params.row;
                if (!rowData) return "";
                return (
                    <LabelColumnV2
                        label={rowData.desc}
                        cellSubMenuOptions={{ options: getOptions({ field: "desc", isQuickFilterDisplay: Boolean(rowData.detailDesc) }), extraData: { fieldName: "desc" } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            field: "carryOutAsType",
            headerName: t("repairRequest.type.label"),
            flex: 1,
            download: true,
            print: true,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.carryOutAsType}
                        cellSubMenuOptions={{ options: getOptions({ field: "carryOutAsType", isQuickFilterDisplay: rowData?.carryOutAsType }), extraData: { fieldName: "carryOutAsType", } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            field: "status",
            headerName: t('general.status'),
            flex: 1,
            download: true,
            type:'singleSelect',
            valueOptions:statusOptions,
            align: "start",
            minWidth: 90,
            print: true,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.status}
                        cellSubMenuOptions={{ options: getOptions({ field: "status", isQuickFilterDisplay: rowData?.status }), extraData: { fieldName: "status", type:'singleSelect'} }}
                        request={rowData}
                    />
                );
            },
        },

    ];
}